module.exports = __webpack_public_path__ + "static/img/exam-ques.b181a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-ques.png
// module id = romw
// module chunks = 1